import InfoStepsBody from "./InfoStepsBody";
import SelectableListBody from "./SelectableListBody";
import AmountInputCardBody from "./AmountInputCardBody";
import OtpInputBody from "./OtpInputBody";
import SuccessBody from "./SuccessBody";

const BODY_TYPE_REGISTRY = {
  INFO_STEPS: InfoStepsBody,
  SELECTABLE_LIST: SelectableListBody,
  AMOUNT_INPUT_CARD: AmountInputCardBody,
  OTP_INPUT: OtpInputBody,
  SUCCESS: SuccessBody,
};

export default BODY_TYPE_REGISTRY;
